import { useMutation } from '@platform/api-client';
import type { ShippingClient } from '@platform/openapi';
import { printPdf } from '../printPdf.ts';
import { saveDownload } from '../saveDownload.ts';
import { usePageContext } from '../usePageContext.ts';

export type LabelUse = 'print' | 'download';

export type LabelRequest = { readonly shipmentId: string; readonly use: LabelUse };

export const useShipmentLabel = (shipping: ShippingClient) => {
  const { t, notify } = usePageContext();
  return useMutation({
    mutationFn: async ({ shipmentId, use }: LabelRequest) => {
      const signed = await shipping.post('/admin/shipments/{id}/label-url', { path: { id: shipmentId } });
      if (use === 'print') await printPdf(signed.url);
      else saveDownload(signed.url);
      return use;
    },
    onSuccess: (use) => {
      if (use === 'download') notify(t('orders.labelDownloaded'));
    },
  });
};
